module.exports = __webpack_public_path__ + "static/media/Qarabag.a2c18036.jpg";